var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TableInquiry"},[_c('div',[_c('inquiry',{ref:"inquirychild",attrs:{"id":_vm.iiid,"partition":_vm.partition}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }